console.log('js/ip_package_selection.js -> v0.1.0');

$(function() {
	if ( $('#inquiry_modal.package-selection').length ) {
		$('.pck-dropdown .dropdown-menu li').click(function() {
			var target = '<span class="selected-option">'+ $(this).find('.package-attributes').html() + '</span>';
			$(this).parents('.dropdown').find('.dropdown-toggle').html(target + '<span class="caret"></span>');

			if ( $(window).width() > 1024 ) {
			}
		});
	}
});
